const DEFAULT_FILTER_BUTTON_SELECTOR = '.Mui-TableHeadCell-Content-Labels .MuiIconButton-root';

const buildMouseEventInit = (target) => {
  const rect = target.getBoundingClientRect();
  const fallbackX = Number.isFinite(rect.left) ? rect.left : 0;
  const fallbackY = Number.isFinite(rect.top) ? rect.top : 0;
  const clientX = fallbackX + Math.max(4, rect.width / 2 || 4);
  const clientY = fallbackY + Math.max(4, rect.height / 2 || 4);
  return {
    bubbles: true,
    cancelable: true,
    composed: true,
    view: window,
    button: 0,
    buttons: 1,
    clientX,
    clientY,
  };
};

const dispatchAnchoredMouseClick = (target) => {
  if (!(target instanceof HTMLElement)) return;
  const eventInit = buildMouseEventInit(target);
  try {
    target.focus({ preventScroll: true });
  } catch (_error) {
    // noop
  }
  target.dispatchEvent(new MouseEvent('mousedown', eventInit));
  target.dispatchEvent(new MouseEvent('mouseup', eventInit));
  target.dispatchEvent(new MouseEvent('click', eventInit));
};

const getFilterButton = ({ table, columnId, buttonSelector }) => {
  if (!table || !columnId) return null;
  const headerCell = table.refs?.tableHeadCellRefs?.current?.[columnId];
  if (!(headerCell instanceof HTMLElement)) return null;
  const selector = buttonSelector || DEFAULT_FILTER_BUTTON_SELECTOR;
  const filterButton = headerCell.querySelector(selector);
  if (!(filterButton instanceof HTMLElement)) return null;
  const style = window.getComputedStyle(filterButton);
  if (style.display === 'none' || style.visibility === 'hidden') return null;
  const rect = filterButton.getBoundingClientRect();
  if (!rect || rect.width < 2 || rect.height < 2) return null;
  return filterButton;
};

export const openMrtFilterPopoverForColumn = ({ table, columnId, buttonSelector }) => {
  if (typeof window === 'undefined') return false;
  const filterButton = getFilterButton({ table, columnId, buttonSelector });
  if (!filterButton) return false;
  dispatchAnchoredMouseClick(filterButton);
  return true;
};

export const scheduleMrtFilterPopoverOpen = ({
  table,
  columnId,
  buttonSelector,
  onComplete,
  maxAttempts = 20,
}) => {
  if (!table || !columnId) return undefined;
  if (typeof window === 'undefined') {
    onComplete?.();
    return undefined;
  }

  let cancelled = false;
  let rafId = 0;
  let attempts = 0;
  let completed = false;

  const finish = () => {
    if (completed) return;
    completed = true;
    onComplete?.();
  };

  const attemptOpen = () => {
    if (cancelled) return;
    attempts += 1;
    const didOpen = openMrtFilterPopoverForColumn({ table, columnId, buttonSelector });
    if (didOpen || attempts >= maxAttempts) {
      finish();
      return;
    }
    rafId = window.requestAnimationFrame(attemptOpen);
  };

  rafId = window.requestAnimationFrame(() => {
    rafId = window.requestAnimationFrame(attemptOpen);
  });

  return () => {
    cancelled = true;
    if (rafId) window.cancelAnimationFrame(rafId);
  };
};
